import axios from "axios"
import { ILoginPayload } from "redux/slices/authSlice"
import { IJobPayload } from "redux/types"

const jobUrl = "/job"

const myAxios = axios.create({ baseURL: "/api" })

export const loginReq = (payload: ILoginPayload) => myAxios.post("/login", payload)

//--------------------Job-Operations---------------------

export const getAllJobsReq = () => myAxios.get(jobUrl + "/query/all")

export const createNewJobReq = (payload: IJobPayload) => myAxios.post(jobUrl + "/create", { job: payload })

export const updateJobReq = (id: string, jobPayload: any) => myAxios.put(jobUrl + "/update/" + id, jobPayload)

export const deleteJobReq = (id: string) => myAxios.delete(jobUrl + "/delete/" + id)

export const getJobByIdReq = (id: string) => myAxios.get(jobUrl + "/byId/" + id)

export const sendApplicationReq = (payload: any) => myAxios.post(jobUrl + "/apply", { payload: payload })